import {
  APPLICATION_STATUS,
  CANDIDATE_BUCKET,
  CANDIDATE_STATUS,
  INTERVIEW_STEPS,
} from '../constants';

export const normalizeStatus = (status) => {
  switch (status) {
    case APPLICATION_STATUS.PENDING:
      return {
        bucket: CANDIDATE_BUCKET.APPLIED,
        workflow: APPLICATION_STATUS.PENDING,
      };

    case APPLICATION_STATUS.IN_PROCESS:
      return {
        bucket: CANDIDATE_BUCKET.SCHEDULED,
        workflow: APPLICATION_STATUS.IN_PROCESS,
      };

    case APPLICATION_STATUS.INTERVIEW_SCHEDULED:
      return {
        bucket: CANDIDATE_BUCKET.SCHEDULED,
        workflow: APPLICATION_STATUS.INTERVIEW_SCHEDULED,
      };

    case APPLICATION_STATUS.APPROVED:
      return {
        bucket: CANDIDATE_BUCKET.SCHEDULED,
        workflow: APPLICATION_STATUS.APPROVED,
      };

    case APPLICATION_STATUS.REJECTED:
      return {
        bucket: CANDIDATE_BUCKET.REJECTED,
        workflow: APPLICATION_STATUS.REJECTED,
      };

    default:
      return {
        bucket: CANDIDATE_BUCKET.APPLIED,
        workflow: status,
      };
  }
};

export function getInterviewRoundLabel(round, fallback = 'Round 1') {
  const index = Number(round);
  return Number.isFinite(index) ? (INTERVIEW_STEPS[index]?.label ?? fallback) : (round ?? fallback);
}

export function getCandidateStatusMeta(candidate) {
  const { bucketStatus, currentInterviewRound } = candidate ?? {};

  switch (bucketStatus) {
    case CANDIDATE_STATUS.SCHEDULED:
      return {
        status: CANDIDATE_STATUS.SCHEDULED,
        label: getInterviewRoundLabel(currentInterviewRound),
        color: 'success.main',
      };

    case CANDIDATE_STATUS.REJECTED:
      return {
        status: CANDIDATE_STATUS.REJECTED,
        label: 'Rejected',
        color: 'error.main',
        roundLabel: getInterviewRoundLabel(currentInterviewRound, null),
      };

    case CANDIDATE_STATUS.APPLIED:
    default:
      return {
        status: CANDIDATE_STATUS.APPLIED,
        label: 'Candidate',
        color: 'warning.main',
      };
  }
}
